/*
  FUNCIÓN GLOBAL QUE INICILIAZA LA APP
 */

import  MetisMenu from 'metismenujs'
import { toastr } from '../../vendors/toast_rails/toast-rails'
import   AppExt   from './app_extend'

export default ( (window,document) => {
    let ctx = {}; // private context
    // PUBLIC APP
    window.App     || (window.App = {});
    App.controller || ( App.controller = {});
    App.main       || (App.main = {});
    App.config     || (App.config = {});

    App.init = () => {

       // window.mm = MetisMenu.attach(".metismenu");

        App.config.ajax = {
            messages: true,
            loader: true,
            redirect_login_url: '/login',
            redirect_locked_url: '/locked'
        };
        console.debug("Debug", $(document.body).data('debug') || false);
        ctx._installEvents();
        ctx._commons();
        ctx._install();
    };

    ctx._install = () => {
        let action, controller;
        controller = $(document.body).data('controller');
        action     = $(document.body).data('action');
        App.main[controller] = App.controller[controller] ? new App.controller[controller] : undefined ;
        if (App.main[controller] && App.main[controller].__proto__.hasOwnProperty(action)) {
            App.main[controller][action]()
        } else {
            console.warn("There is no " + controller + " or " + action + " action to initialise.Check if needed, or omit this warning.");
        }
    };

    ctx._onAjaxComplete = (e) => {
        let dataset, item, msg, obj, _i, _len, _ref,_xhr;
        _xhr =  e.detail[0]
        App.utils.loaderOFF();
        msg = _xhr.getResponseHeader('X-Message');
        if (App.config.ajax.messages) {
            if (JSON.parse(msg) instanceof Array) {
                _ref = obj = JSON.parse(msg);
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                    item = _ref[_i];
                    item[1] = utf8_decode(item[1]);
                }
                setTimeout((function() {
                    return App.utils.autonotify(obj);
                }), 100);
            }
        } else {
            console.log("ajax.messages=false , suprimidos los mensajes globales ->" + msg);
        }
        dataset = e.target.dataset || _xhr.dataset;
        if (dataset && dataset.remote) {
            return ctx._executeFunctionsOnAjaxComplete();
        }
    };

    ctx._onAjaxBeforeSend = (e)=> {
        let _ref, _ref1, _ref2, _xhr;
        _xhr =  e.detail[0]
        _xhr.dataset || (_xhr.dataset = {});
        if (((_ref = e.target.dataset) != null ? _ref.remote : void 0) != null) {
            _xhr.dataset.remote = true;
        }
        if (((_ref1 = e.target.dataset) != null ? _ref1.controller : void 0) != null) {
            _xhr.dataset.controller = e.target.dataset.controller;
        }
        console.log('ajax:beforesend =>' + JSON.stringify(_xhr.dataset));
        ctx._setLoader(e);
        if (((_ref2 = e.target.dataset) != null ? _ref2.controller : void 0) != null) {
            //return injectionClass.apply(this, [e.target.dataset.controller]);
        }
    };

    ctx._onAjaxStart = (e) => {};

    ctx._setLoader = (e)=> {
        let loader;
        loader = $(e.target).data('loader') || $(e.target.activeElement).data('loader');
        if (loader === void 0) {
            loader = false;
        }
        if (loader === true && App.config.ajax.loader) {
            setTimeout((function() {
                return App.utils.loaderON();
            }), 10);
        }
    };

    ctx._onAjaxError = (e ) => {
        let _xhr =  e.detail[2]
        App.utils.loaderOFF();
        if (_xhr.status >= 500 || (_xhr.status === 422 && !_xhr.responseType == 'json')) {
            App.utils.notify.error(App.messages.global.errorAjax);
        }
        if (_xhr.status === 401) {
            //window.location.href = App.config.ajax.redirect_login_url;
        }
        if (_xhr.status === 423) {
            return window.location.href = App.config.ajax.redirect_locked_url;
        }
    };

    ctx._onAjaxRailsErrorValidations = (e) => {
        let key, value, _ref, _xhr;
        _xhr =  e.detail[2]
        App.utils.loaderOFF();
        if (_xhr.status === 422 && (_xhr.responseType == 'json' || /^\[?{.+?}\]?$/gmi.test(_xhr.responseText))) {
            $(e.target).find('.is-invalid').removeClass("is-invalid").next('div.invalid-feedback').remove();
            try { _ref = JSON.parse(_xhr.responseText)} catch(e) { _ref ={}; console.error('Invalid parse JSON',_xhr.responseText) }
            for (key in _ref) {
                value = _ref[key];
                $(e.target).find('[name$="[' + key + ']"],#' + key).eq(0).addClass("is-invalid").parent().append('<div class="invalid-feedback">' + $.map(value, function(m) {
                    return m.charAt(0).toUpperCase() + m.slice(1);
                }).join('<br />') + '</div>');
            }
        }
    };

    ctx._installEvents = () => {

        if (App.main) ctx._uninstallEvents();

        document.addEventListener('ajax:complete',      ctx._onAjaxComplete);
        document.addEventListener('ajax:beforeSend',    ctx. _onAjaxBeforeSend);
        document.addEventListener('ajax:start',         ctx._onAjaxStart);
        document.addEventListener('ajax:error',         ctx._onAjaxError);
        document.addEventListener('ajax:error',         ctx._onAjaxRailsErrorValidations);
    };

    ctx._uninstallEvents = () => {
        document.removeEventListener('ajax:complete',     ctx._onAjaxComplete);
        document.removeEventListener('ajax:beforeSend',   ctx._onAjaxBeforeSend);
        document.removeEventListener('ajax:start',        ctx._onAjaxStart);
        document.removeEventListener('ajax:error',        ctx._onAjaxError);
        document.removeEventListener('ajax:error',        ctx._onAjaxRailsErrorValidations);
    };

    ctx._executeFunctionsOnAjaxComplete = () => {

    };

    ctx._commons = () => {

        toastr.options = {
            "closeButton": false,
            "debug": false,
            "positionClass": "toast-top-right",
            "onclick": null,
            "showDuration": "700",
            "hideDuration": "300",
            "timeOut": "900",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };


    };

    // ENTRYPOINT
    App.start =  () => {

        window.addEventListener('DOMContentLoaded', (event) => {
            console.warn('On ready DOMContentLoaded');
            App.init();
        });

    }
    // EXTENDING APP
    const append = new AppExt(ctx); // passing private fn()
    Object.assign(App, append); // Extend App
    return App;

})(window, document);
